module.exports = __webpack_public_path__ + "static/media/solar.fb2538db.png";